import { useParams } from "react-router-dom";

interface ClientParams {
  clientId: string;
}

export const useClientParams = () => useParams() as Readonly<ClientParams>;
